import React, { FC } from 'react';

import { useTranslate } from '@/shared/hooks/use-translate';
import { Layout } from '@/shared/ui/layout';
import { TabsAnt } from '@/shared/ui/tabs';

import * as Styled from './styled';
import { TabCharacteristics, TabCharacteristicsProps } from './tab-characteristics';
import { TabDescription } from './tab-description';

type TProps = {
    description: string;
    options: TabCharacteristicsProps[];
};

export const ProductTabs: FC<TProps> = ({ description, options }) => {
    const { t } = useTranslate();

    const itemsTabs = [
        { label: t('Описание'), key: 'item-1', children: <TabDescription description={description} /> }, // Remember to pass the key prop
        { label: t('Характеристики'), key: 'item-2', children: <TabCharacteristics data={options} /> },
    ];

    return (
        <Styled.Wrapper>
            <Layout.CardConent>
                <TabsAnt items={itemsTabs} />
            </Layout.CardConent>
        </Styled.Wrapper>
    );
};
